"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ACTION TYPE CONSTANTS*/

var FETCH_POLICY_REQUEST = 'app/policy/FETCH_POLICY_REQUEST';
var FETCH_POLICY_SUCCESS = 'app/policy/FETCH_POLICY_SUCCESS';
var FETCH_POLICY_FAILURE = 'app/policy/FETCH_POLICY_FAILURE';
var FETCH_POLICY_BILLING_REQUEST = 'app/policy/FETCH_POLICY_BILLING_REQUEST';
var FETCH_POLICY_BILLING_SUCCESS = 'app/policy/FETCH_POLICY_BILLING_SUCCESS';
var FETCH_POLICY_BILLING_FAILURE = 'app/policy/FETCH_POLICY_BILLING_FAILURE';
var FETCH_POLICY_DOCUMENTS_REQUEST = 'app/policy/FETCH_POLICY_DOCUMENTS_REQUEST';
var FETCH_POLICY_DOCUMENTS_SUCCESS = 'app/policy/FETCH_POLICY_DOCUMENTS_SUCCESS';
var FETCH_POLICY_DOCUMENTS_FAILURE = 'app/policy/FETCH_POLICY_DOCUMENTS_FAILURE';
var FETCH_POLICY_VEHICLE_LIST_REQUEST = 'app/policy/FETCH_POLICY_VEHICLE_LIST_REQUEST';
var FETCH_POLICY_VEHICLE_LIST_SUCCESS = 'app/policy/FETCH_POLICY_VEHICLE_LIST_SUCCESS';
var FETCH_POLICY_VEHICLE_LIST_FAILURE = 'app/policy/FETCH_POLICY_VEHICLE_LIST_FAILURE';
var FETCH_COVERAGE_FORMS_REQUEST = 'app/policy/FETCH_COVERAGE_FORMS_REQUEST';
var FETCH_COVERAGE_FORMS_SUCCESS = 'app/policy/FETCH_COVERAGE_FORMS_SUCCESS';
var FETCH_COVERAGE_FORMS_FAILURE = 'app/policy/FETCH_COVERAGE_FORMS_FAILURE';
var ASSOCIATE_POLICY_REQUEST = 'app/policy/ASSOCIATE_POLICY_REQUEST';
var ASSOCIATE_POLICY_SUCCESS = 'app/policy/ASSOCIATE_POLICY_SUCCESS';
var ASSOCIATE_POLICY_FAILURE = 'app/policy/ASSOCIATE_POLICY_FAILURE';
var ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_REQUEST = 'app/policy/ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_REQUEST';
var ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_SUCCESS = 'app/policy/ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_SUCCESS';
var ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_FAILURE = 'app/policy/ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_FAILURE';
var ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_REQUEST = 'app/policy/ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_REQUEST';
var ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_SUCCESS = 'app/policy/ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_SUCCESS';
var ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_FAILURE = 'app/policy/ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_FAILURE';
var FETCH_SAFELITE_DETAILS_REQUEST = 'app/policy/FETCH_SAFELITE_DETAILS_REQUEST';
var FETCH_SAFELITE_DETAILS_SUCCESS = 'app/policy/FETCH_SAFELITE_DETAILS_SUCCESS';
var FETCH_SAFELITE_DETAILS_FAILURE = 'app/policy/FETCH_SAFELITE_DETAILS_FAILURE';
var ASSOCIATE_POLICY_CLEAR = 'app/policy/ASSOCIATE_POLICY_CLEAR';
var _default = exports.default = {
  FETCH_POLICY_REQUEST: FETCH_POLICY_REQUEST,
  FETCH_POLICY_SUCCESS: FETCH_POLICY_SUCCESS,
  FETCH_POLICY_FAILURE: FETCH_POLICY_FAILURE,
  FETCH_POLICY_BILLING_REQUEST: FETCH_POLICY_BILLING_REQUEST,
  FETCH_POLICY_BILLING_SUCCESS: FETCH_POLICY_BILLING_SUCCESS,
  FETCH_POLICY_BILLING_FAILURE: FETCH_POLICY_BILLING_FAILURE,
  FETCH_POLICY_DOCUMENTS_REQUEST: FETCH_POLICY_DOCUMENTS_REQUEST,
  FETCH_POLICY_DOCUMENTS_SUCCESS: FETCH_POLICY_DOCUMENTS_SUCCESS,
  FETCH_POLICY_DOCUMENTS_FAILURE: FETCH_POLICY_DOCUMENTS_FAILURE,
  FETCH_COVERAGE_FORMS_REQUEST: FETCH_COVERAGE_FORMS_REQUEST,
  FETCH_COVERAGE_FORMS_SUCCESS: FETCH_COVERAGE_FORMS_SUCCESS,
  FETCH_COVERAGE_FORMS_FAILURE: FETCH_COVERAGE_FORMS_FAILURE,
  FETCH_POLICY_VEHICLE_LIST_REQUEST: FETCH_POLICY_VEHICLE_LIST_REQUEST,
  FETCH_POLICY_VEHICLE_LIST_SUCCESS: FETCH_POLICY_VEHICLE_LIST_SUCCESS,
  FETCH_POLICY_VEHICLE_LIST_FAILURE: FETCH_POLICY_VEHICLE_LIST_FAILURE,
  ASSOCIATE_POLICY_REQUEST: ASSOCIATE_POLICY_REQUEST,
  ASSOCIATE_POLICY_SUCCESS: ASSOCIATE_POLICY_SUCCESS,
  ASSOCIATE_POLICY_FAILURE: ASSOCIATE_POLICY_FAILURE,
  ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_REQUEST: ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_REQUEST,
  ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_SUCCESS: ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_SUCCESS,
  ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_FAILURE: ASSOCIATE_POLICY_GET_SECURITY_QUESTIONS_FAILURE,
  ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_REQUEST: ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_REQUEST,
  ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_SUCCESS: ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_SUCCESS,
  ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_FAILURE: ASSOCIATE_POLICY_POST_SECURITY_QUESTIONS_FAILURE,
  ASSOCIATE_POLICY_CLEAR: ASSOCIATE_POLICY_CLEAR,
  FETCH_SAFELITE_DETAILS_FAILURE: FETCH_SAFELITE_DETAILS_FAILURE,
  FETCH_SAFELITE_DETAILS_SUCCESS: FETCH_SAFELITE_DETAILS_SUCCESS,
  FETCH_SAFELITE_DETAILS_REQUEST: FETCH_SAFELITE_DETAILS_REQUEST
};